import { withTheme } from 'emotion-theming';
import React, { useState } from 'react';
import styled, { css } from 'react-emotion';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { constructGallery } from '@jetshop/ui/Gallery/constructGallery';
import Image from '@jetshop/ui/Image/Image';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import get from 'lodash.get';
import { Redirect } from 'react-router-dom';

const Wrapper = styled('div')`
  position: relative;
  img {
    max-height: 100vh;
  }
  .image-gallery-image {
    text-align: center;
  }
  .image-gallery-thumbnail-inner {
    font-size: 10px;
  }
  .image-gallery-right-nav,
  .image-gallery-left-nav,
  .image-gallery-fullscreen-button {
    font-size: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    height: 2.5rem;
    width: 2.5rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.4);
    transition: background 0.3s ease-in-out;
    margin: 0 0.5rem;
    &:hover {
      background: rgba(255, 255, 255, 0.8);
    }
    &:before {
      color: black;
      text-shadow: none;
    }
  }
  .image-gallery-fullscreen-button {
    margin-bottom: 0.5rem;
  }
  .image-gallery-fullscreen-button:before {
    text-shadow: none;
    font-size: 0.7em;
    padding: 0;
  }
  .image-gallery-thumbnail.active {
    border-width: 1px;
  }
  .image-gallery-thumbnails-wrapper.left .image-gallery-thumbnails,
  .image-gallery-thumbnails-wrapper.right .image-gallery-thumbnails {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .fullscreen {
    .image-gallery-fullscreen-button {
      margin: 2rem;
    }
    .image-gallery-right-nav,
    .image-gallery-left-nav {
      margin: 0 2rem;
    }
    img {
      width: auto;
      max-width: 100%;
    }
    .image-gallery-thumbnails-wrapper {
      display: none;
    }
  }
`;
const Overlay = styled('div')`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`;

//const SearchVariantGallery = function Gallery(props) {
//class SearchVariantGallery extends Component {
const SearchVariantGallery = props => {
  const [redirect, setRedirect] = useState('');

  const {
    sizes = [1, 1, 1 / 2, 1 / 2],
    fullScreenSizes = [1, 1, 1, 1],
    thumbnailSizes = ['5rem'],
    aspect = '1:1',
    thumbnailPosition = 'bottom',
    backgroundColor = 'white',
    thumbnailQuality,
    quality,
    theme,
    variants
  } = props;
  const { selectedChannel } = React.useContext(ChannelContext);
  const baseUrl = get(selectedChannel, 'url')
    ? String(selectedChannel.url)
    : null;
  const [isFullscreen, setFullscreen] = React.useState(false);

  const currentProductCat = props.product.primaryRoute.path.split('/')[1];

  let customImages = [];
  let filterVariants = variants.filter(variant => {
    return currentProductCat === variant.primaryRoute.path.split('/')[1]
      ? variant
      : null;
  });

  filterVariants.sort(function(a, b) {
    return a.name.localeCompare(b.name);
  });

  let currentProductIndex = 0;
  filterVariants.forEach((variant, i) => {
    customImages.push(variant.images[0]);
    console.log('props.product.images[0]', props.product.images[0]);
    console.log('variant.images[0]', variant.images[0]);
    if (props.product.images[0].url === variant.images[0].url) {
      currentProductIndex = i;
    }
  });

  const galleryImages = React.useMemo(
    () =>
      constructGallery(customImages, theme, fullScreenSizes, aspect, baseUrl),
    [aspect, baseUrl, fullScreenSizes, theme, customImages]
  );

  const thumbCallback = event => {
    const clickedThumb = event.target;
    let child = clickedThumb.parentElement.parentElement;
    let i = 0;
    while ((child = child.previousSibling) != null) i++;
    setRedirect(filterVariants[i].primaryRoute.path);
  };

  const slideCallback = currentIndex => {
    //setRedirect(filterVariants[currentIndex].primaryRoute.path);
    //console.log("index", currentIndex);
  };

  const navCallback = event => {
    const clickedThumb = event.target;
    let activeThumb = document.querySelector('.image-gallery-thumbnail.active');

    let i = 0;
    while ((activeThumb = activeThumb.previousSibling) != null) i++;

    if (clickedThumb.className === 'image-gallery-left-nav') {
      if (filterVariants[i - 1]) {
        setRedirect(filterVariants[i - 1].primaryRoute.path);
      }
    } else {
      if (filterVariants[i + 1]) {
        setRedirect(filterVariants[i + 1].primaryRoute.path);
      }
    }
  };

  if (redirect !== '') {
    const currentLocation = window.location.pathname;
    if (currentLocation !== redirect) {
      return <Redirect to={redirect} />;
    }
  }

  return React.createElement(
    Wrapper,
    {
      className: `${css`
        .image-gallery-slide {
          background-color: ${backgroundColor};
        }
      `}`
    },
    React.createElement(ImageGallery, {
      startIndex: currentProductIndex,
      showNav: true,
      thumbnailPosition: thumbnailPosition,
      items: galleryImages,
      autoPlay: false,
      showPlayButton: false,
      useBrowserFullscreen: false,
      preventDefaultTouchmoveEvent: isFullscreen,
      onScreenChange: el => setFullscreen(!!el),
      onSlide: slideCallback,
      onThumbnailClick: thumbCallback,
      renderLeftNav: (onClick, disabled) => {
        return (
          <button className="image-gallery-left-nav" onClick={navCallback} />
        );
      },
      renderRightNav: (onClick, disabled) => {
        return (
          <button className="image-gallery-right-nav" onClick={navCallback} />
        );
      },
      renderItem: item => {
        return React.createElement(
          'div',
          { className: 'image-gallery-image' },
          isFullscreen
            ? React.createElement('img', {
                src: item.original,
                alt: item.originalAlt,
                srcSet: item.srcSet,
                sizes: item.sizes,
                title: item.originalTitle
              })
            : React.createElement(
                React.Fragment,
                null,
                React.createElement(Image, {
                  src: item.original,
                  alt: item.originalAlt,
                  sizes: sizes,
                  title: item.originalTitle,
                  aspect: aspect,
                  quality: quality
                }),
                props.children &&
                  React.createElement(Overlay, null, props.children)
              )
        );
      },
      renderThumbInner: item => {
        return React.createElement(
          'div',
          { className: 'image-gallery-thumbnail-inner' },
          React.createElement(Image, {
            src: item.thumbnail,
            alt: item.thumbnailAlt,
            title: item.thumbnailTitle,
            sizes: thumbnailSizes,
            aspect: aspect,
            quality: thumbnailQuality
          }),
          item.thumbnailLabel &&
            React.createElement(
              'div',
              { className: 'image-gallery-thumbnail-label' },
              item.thumbnailLabel
            )
        );
      }
    })
  );
};
export default withTheme(SearchVariantGallery);

